// extracted by mini-css-extract-plugin
module.exports = {"label":"productLabels_label__cQwJl","customLabel":"productLabels_customLabel__g9BuG","attributeLabel":"productLabels_attributeLabel__phVQJ"};